import { Directive, EmbeddedViewRef, Input, NgModule, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appFeatureToggle]'
})
export class FeatureToggleDirective implements OnInit, OnDestroy {

  @Input('appFeatureToggle') featureSettingKey: string;
  subscription: Subscription;
  embeddedView: EmbeddedViewRef<any>;

  constructor(
    private featureSettingsStoreService: FeatureSettingsStoreService,
    private vcr: ViewContainerRef,
    private tpl: TemplateRef<any>) { }

  ngOnInit(): void {
    if (this.featureSettingKey) {
      this.subscription = this.featureSettingsStoreService.state$.subscribe(state => {
        if (state[this.featureSettingKey]) {
          if (!this.embeddedView) {
            this.embeddedView = this.vcr.createEmbeddedView(this.tpl);
          }
        } else {
          this.vcr.clear();
          this.embeddedView = null;
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription && this.subscription.unsubscribe();
  }

}
@NgModule({
  declarations: [FeatureToggleDirective],
  exports: [FeatureToggleDirective],
})
export class FeatureToggleModule { }
